import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard, NavComponent } from '@unilog/template';
import { HomeComponent } from './home/home.component';
import { ParamCollComponent } from './param-coll/param-coll.component';
import { ParamCompComponent } from './param-comp/param-comp.component';
import { ParamContratComponent } from './param-contrat/param-contrat.component';
import { ParamActionComponent } from './param-action/param-action.component';
import { ParamCompteComponent } from './param-compte/param-compte.component';
import { ParamHeurComponent } from './param-heur/param-heur.component';
import { ParamTauxComponent } from './param-taux/param-taux.component';
import { ListeCollaborateursComponent } from './liste-collaborateurs/liste-collaborateurs.component';
import { ListeClientsComponent } from './liste-clients/liste-clients.component';
import { PlanningActionComponent } from './planning-action/planning-action.component';
import { SuivieCollDialogComponent } from './suivie-coll-dialog/suivie-coll-dialog.component';
import { GenerateFactureComponent } from './generate-facture/generate-facture.component';
import { RessourcesComponent } from './ressources/ressources.component';
import { AvtEchangeComponent } from './avt-echange/avt-echange.component';
import { AvtAlertComponent } from './avt-alert/avt-alert.component';
import { AvtEvenementComponent } from './avt-evenement/avt-evenement.component';
import { AvtParamComponent } from './avt-param/avt-param.component';
import { AvtGestDroitUserComponent } from './avt-gest-droit-user/avt-gest-droit-user.component';
import { AvtMatiereCursusComponent } from './avt-matiere-cursus/avt-matiere-cursus.component';
import { AvtActionComponent } from './avt-action/avt-action.component';
import { AvtSalleComponent } from './avt-salle/avt-salle.component'; /////17/12/2019
import { AvtListeEvennementComponent } from './avt-liste-evennement/avt-liste-evennement.component';
import { AvtMachineComponent } from './avt-machine/avt-machine.component';
import { AvtListeMachineComponent } from './avt-liste-machine/avt-liste-machine.component';
import { AvtListeEvaluationsComponent } from './avt-liste-evaluations/avt-liste-evaluations.component';
import { AvtDocumentComponent } from './avt-document/avt-document.component';
import { AvtListeDocumentComponent } from './avt-liste-document/avt-liste-document.component';
import { AvtRessourcesPedagogiqueComponent } from './avt-ressources-pedagogique/avt-ressources-pedagogique.component';
import { AvtCursusComponent } from './avt-cursus/avt-cursus.component';
import { AvtListeCursusComponent } from './avt-liste-cursus/avt-liste-cursus.component';
import { AvtSuiviePedNoteComponent } from './avt-suivie-ped-note/avt-suivie-ped-note.component';
import { AvtSuiviePedAppreciationComponent } from './avt-suivie-ped-appreciation/avt-suivie-ped-appreciation.component';
import { AvtNoteFraisComponent } from './avt-note-frais/avt-note-frais.component';
import { AvtMachineReservationComponent } from './avt-machine-reservation/avt-machine-reservation.component';
import { AvtListeMachineReservationComponent } from './avt-liste-machine-reservation/avt-liste-machine-reservation.component';
import { AvtMatiereComponent } from './avt-matiere/avt-matiere.component';
import { AvtListeMatiereComponent } from './avt-liste-matiere/avt-liste-matiere.component';
import { ActionPrestationComponent } from './action-prestation/action-prestation.component';
import { ClientComponent } from './client/client.component';
import { CollaborateurComponent } from './collaborateur/collaborateur.component';
import { PlanningComponent } from './planning/planning.component';
import { PlanningClientComponent } from './planning-client/planning-client.component';
import { ActiviterComponent } from './activiter/activiter.component';
import { AvtPlanningComponent } from './avt-planning/avt-planning.component';
import { AvtInterlocuteurComponent } from './avt-interlocuteur/avt-interlocuteur.component';
import { GrhCongeComponent } from './grh/grh-conge/grh-conge.component';
import { GrhFicheComponent } from './grh/grh-fiche/grh-fiche.component';
import { HotelReservationComponent } from './hotel/hotel-reservation/hotel-reservation.component';
import { GrhAccidentComponent } from './grh/grh-accident/grh-accident.component';
import { PrintComponent } from './print/print.component';
import { CasteloPresentationComponent } from './castelo/castelo-presentation/castelo-presentation.component';
import { QuestionnaireComponent } from './mme-rekik/questionnaire/questionnaire.component';
import { CaisseComponent } from './caisse/caisse/caisse.component';
import { CloseCaisseComponent } from './caisse/close-caisse/close-caisse.component';
import { OpenCaisseComponent } from './caisse/open-caisse/open-caisse.component';
import { StateCaisseComponent } from './caisse/state-caisse/state-caisse.component';
import { TicketListComponent } from './caisse/ticket-list/ticket-list.component';
import { ListeReservationComponent } from './hotel/liste-reservation/liste-reservation.component';
import { AvtListeAlertComponent } from './avt-liste-alert/avt-liste-alert.component';
import { AvtListeEchangeComponent } from './avt-liste-echange/avt-liste-echange.component';
import { SimedArticleComponent } from './simed/article/article.component';
import { SimedReceptionEchantillionComponent } from './simed/simed-reception-echantillion/simed-reception-echantillion.component';
import { SimedAnalyseComponent } from './simed/simed-analyse/simed-analyse.component';
import { SuiviCodeBarreComponent } from './caisse/suivi-code-barre/suivi-code-barre.component';
import { DashboardSuiviComponent } from './caisse/dashboard-suivi/dashboard-suivi.component';
import { RapportVisiteConsultComponent } from './CRM/rapport-visite-consult/rapport-visite-consult.component';
import { FicheClientComponent } from './CRM/fiche-client/fiche-client.component';
import { ReclamationComponent } from './CRM/reclamation/reclamation.component';
import { StockComponent } from './CRM/stock/stock.component';
import { AjouterHierarchieComponent } from './Hierarchie/ajouter-hierarchie/ajouter-hierarchie.component';
import { TableRComponent } from './table-r/table-r.component';
import { NouveauxEmployesComponent } from './grh/nouveaux-employes/nouveaux-employes.component';
import { SuiviProductionComponent } from './suivi-production/suivi-production.component';
import { ShopfloorOverviewComponent } from './shopfloor-overview/shopfloor-overview.component';
import { CommandComponent } from './CRM/command/command.component';
import { RecapAnalyseComponent } from './recap-analyse/recap-analyse.component';
import { RecapExportComponent } from './recap-export/recap-export.component';
import { RecommandationsComponent } from './CRM/recommandations/recommandations.component';
import { DevisComponent } from './CRM/devis/devis.component';
import { AddRapportVisiteComponent } from './CRM/add-rapport-visite/add-rapport-visite.component';
import { TreeTableComponent } from './tree-table/tree-table.component';
import { TableauStatistiqueComponent } from './caisse/tableau-statistique/tableau-statistique.component';
import { DevToolsComponent } from './dev-tools/dev-tools.component';
import { BureauEtudeComponent } from './bureau-etude/bureau-etude.component';
import { RechuteComponent } from './grh/rechute/rechute.component';
import { RapportStatComponent } from './grh/rapport-stat/rapport-stat.component';
import { MaladiProfComponent } from './grh/maladi-prof/maladi-prof.component';
import { PlanningCrmComponent } from './CRM/planning-crm/planning-crm.component';
import { EcartComponent } from './qualite/ecart/ecart.component';
import { ReunionComponent } from './qualite/reunion/reunion.component';
import { ConsultMaladieProComponent } from './grh/consult-maladie-pro/consult-maladie-pro.component';
import { ConsultAccidentComponent } from './grh/consult-accident/consult-accident.component';
import { TarifReservationComponent } from './hotel/tarif-reservation/tarif-reservation.component';
import { ImpressionComponent } from './hotel/impression/impression.component';
import { FournisseurComponent } from './hotel/fournisseur/fournisseur.component';
import { BraquetComponent } from './hotel/braquet/braquet.component';
import { MenuRestaurantComponent } from './hotel/menu-restaurant/menu-restaurant.component';
const routes: Routes = [
  { path: 'dev-tools', component: DevToolsComponent },
  // { path: 'tableauStatistique', component: TableauStatistiqueComponent },
  { path: 'ficheClient', component: FicheClientComponent },

  // -----------------------------
  { path: 'w/print', component: PrintComponent },
  { path: 'avt/mmerekik/questionnaire', component: QuestionnaireComponent },
  { path: 'avt/castelo/presentation', component: CasteloPresentationComponent },
  { path: 'grh/accident', component: GrhAccidentComponent },
  {
    path: 'w/avt/parametre/liste/clients/:param',
    component: ListeClientsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'w/action/prestation/:typeAction',
    component: ActionPrestationComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'w/avt/parametre/liste/collaborateurs/:param',
    component: ListeCollaborateursComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'w/avt/liste/cursus',
    component: AvtListeCursusComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'w/avt/liste/machine/:type',
    component: AvtListeMachineComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'w/avt/action/:param_code/:typeAction/:typeTrs',
    component: AvtActionComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'w/avt/client/:param_code/:typeTrs/:typeClient',
    component: ClientComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'w/avt/collaborateur/:param_code/:typeTrs/:typeColl',
    component: CollaborateurComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'w/avt/cursus/:param_code/:typeTrs',
    component: AvtCursusComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'w/avt/machine/:param_code/:typeTrs',
    component: AvtMachineComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'w/avt/salle/:param_code/:typeTrs',
    component: AvtSalleComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'w/avt/document/:param_code/:typeTrs/:fenetre/:mode/:Tiers_code/:indexTabs/:avtAction_Code',
    component: AvtDocumentComponent,
  },
  {
    path: 'w/avt/liste/document/:fenetre/:mode/:random',
    component: AvtListeDocumentComponent,
  },
  {
    path: 'w/avt/Interlocuteur/:TiersC_Id/:Tiers_code',
    component: AvtInterlocuteurComponent,
  },
  {
    path: 'w/avt/reservation/machine',
    component: AvtMachineReservationComponent,
  },
  {
    path: 'w/avt/document/:param_code/:typeTrs/:fenetre',
    component: AvtDocumentComponent,
  },
  {
    path: 'w/avt/evenement/:param_code/:typeTrs',
    component: AvtEvenementComponent,
  },
  { path: 'grh/nouveauxEmployes', component: NouveauxEmployesComponent },
  { path: 'grh/malProf', component: MaladiProfComponent },

  { path: 'w/avt/liste/evenement', component: AvtListeEvennementComponent },

  {
    path: 'avt',
    component: NavComponent,
    children: [
      {
        path: 'tableauStatistique',
        component: TableauStatistiqueComponent,
        canActivate: [AuthGuard],
      },
      { path: 'grh/accident', component: GrhAccidentComponent },
      { path: 'grh/accident/:id', component: GrhAccidentComponent },
      { path: 'grh/nouveauxEmployes', component: NouveauxEmployesComponent },
      { path: 'grh/rechute', component: RechuteComponent },
      { path: 'grh/statistique', component: RapportStatComponent },
      { path: 'grh/malProf', component: MaladiProfComponent },
      {
        path: 'grh/consultationMaladie',
        component: ConsultMaladieProComponent,
      },
      { path: 'grh/consultationAccident', component: ConsultAccidentComponent },
      {
        path: 'table-R/:param',
        component: TableRComponent,
      },
      { path: '', redirectTo: 'avt/home', pathMatch: 'full' },
      {
        path: 'grh/reservation/:param/:mode',
        component: HotelReservationComponent,
      },
      { path: 'grh/liste/reservation', component: ListeReservationComponent },
      { path: 'grh/liste/modeles', component: ListeReservationComponent },
      {
        path: 'grh/tarif/reservation/:tiersName/:param',
        component: TarifReservationComponent,
      },
      {
        path: 'grh/tarif/reservation',
        component: TarifReservationComponent,
      },
      { path: 'grh/fournisseur/reservation', component: FournisseurComponent },
      { path: 'grh/reservation/impression', component: ImpressionComponent },
      { path: 'grh/braquet/reservation', component: BraquetComponent },
      {
        path: 'grh/menu-resto/reservation',
        component: MenuRestaurantComponent,
      },

      { path: 'mmerekik/questionnaire', component: QuestionnaireComponent },
      { path: 'castelo/presentation', component: CasteloPresentationComponent },
      {
        path: 'planning/:ecran/:param_code/:date/:intervale',
        component: AvtPlanningComponent,
      },
      { path: 'home', component: HomeComponent },
      {
        path: 'action/prestation/:typeAction',
        component: ActionPrestationComponent,
      },
      { path: 'action/planglobal', component: PlanningComponent },
      { path: 'planning/:param', component: PlanningComponent },
      {
        path: 'client/:param_code/:typeTrs/:typeClient',
        component: ClientComponent,
      },
      {
        path: 'collaborateur/:param_code/:typeTrs/:typeColl',
        component: CollaborateurComponent,
      },
      {
        path: 'action/:param_code/:typeAction/:typeTrs',
        component: AvtActionComponent,
      },
      // { path: 'planningcollaborateur/:param_code/:date/:intervale', component: PlanningCollaborateurComponent},
      {
        path: 'planningclient/:param_code/:date/:intervale',
        component: PlanningClientComponent,
      },
      { path: 'fraiscollaborateur/:fenetre', component: AvtNoteFraisComponent },
      { path: 'parametre/collaborateur', component: ParamCollComponent },
      { path: 'parametre/competence', component: ParamCompComponent },
      { path: 'parametre/contrat', component: ParamContratComponent },
      { path: 'parametre/action', component: ParamActionComponent },
      { path: 'parametre/compte', component: ParamCompteComponent },
      { path: 'parametre/heure', component: ParamHeurComponent },
      { path: 'parametre/taux', component: ParamTauxComponent },
      {
        path: 'parametre/liste/collaborateurs/:param',
        component: ListeCollaborateursComponent,
      },
      {
        path: 'parametre/liste/clients/:param',
        component: ListeClientsComponent,
      },
      {
        path: 'planning/action/:param/:date/:intervale',
        component: PlanningActionComponent,
      },
      { path: 'suivie/coll/dialog', component: SuivieCollDialogComponent },
      { path: 'generate/facture', component: GenerateFactureComponent },
      { path: 'ressources/:type', component: RessourcesComponent },
      { path: 'echanges/:param_code', component: AvtEchangeComponent },
      { path: 'alert/:param_code', component: AvtAlertComponent },
      { path: 'interlocuteur/:param_code', component: AvtAlertComponent },
      {
        path: 'evenement/:param_code/:typeTrs',
        component: AvtEvenementComponent,
      },
      { path: 'param', component: AvtParamComponent },
      { path: 'matiere/:param_code', component: AvtMatiereCursusComponent },
      { path: 'gest/droit/user', component: AvtGestDroitUserComponent },
      { path: 'salle/:param_code/:typeTrs', component: AvtSalleComponent },
      { path: 'liste/evenement', component: AvtListeEvennementComponent },
      { path: 'machine/:param_code/:typeTrs', component: AvtMachineComponent },
      { path: 'liste/machine/:type', component: AvtListeMachineComponent },
      {
        path: 'liste/evaluations/:param_code/:fenetre',
        component: AvtListeEvaluationsComponent,
      },
      {
        path: 'document/:param_code/:typeTrs/:fenetre',
        component: AvtDocumentComponent,
      },
      { path: 'liste/document/:fenetre', component: AvtListeDocumentComponent },
      {
        path: 'ressources/pedagogique/:fenetre',
        component: AvtRessourcesPedagogiqueComponent,
      },
      { path: 'cursus/:param_code/:typeTrs', component: AvtCursusComponent },
      { path: 'liste/cursus', component: AvtListeCursusComponent },
      { path: 'saisie/note/evaluation', component: AvtSuiviePedNoteComponent },
      {
        path: 'saisie/appreciation/evaluation/:fenetre',
        component: AvtSuiviePedAppreciationComponent,
      },
      { path: 'note/frais/:fenetre', component: AvtNoteFraisComponent },
      { path: 'conges', component: GrhCongeComponent },
      {
        path: 'reservation/machine',
        component: AvtMachineReservationComponent,
      },
      { path: 'fiche/paie/:param_code/:fenetre', component: GrhFicheComponent },
      {
        path: 'liste/reservation/:fenetre',
        component: AvtListeMachineReservationComponent,
      },
      { path: 'matiere', component: AvtMatiereComponent },
      { path: 'liste/matiere', component: AvtListeMatiereComponent },
      { path: 'activiter/:periode', component: ActiviterComponent },
      { path: 'liste/alert', component: AvtListeAlertComponent },
      { path: 'liste/echange', component: AvtListeEchangeComponent },
      //------------------------------ caise------------------------------
      { path: 'caisse', component: CaisseComponent },
      { path: 'close/:param/:mode', component: CloseCaisseComponent },
      { path: 'open', component: OpenCaisseComponent },
      { path: 'state', component: StateCaisseComponent },
      { path: 'ticket-list', component: TicketListComponent },
      //------------------------------ fin caise------------------------------
      //------------------------------CRM-------------------------------------
      {
        path: 'CRM',
        children: [
          { path: 'ficheClient', component: FicheClientComponent },
          {
            path: 'Ajouter-rapport-visite',
            component: AddRapportVisiteComponent,
          },
          {
            path: 'rapport-visite',
            component: RapportVisiteConsultComponent,
          },

          { path: 'Recommandation', component: RecommandationsComponent },
          { path: 'reclamation', component: ReclamationComponent },
          { path: 'stock', component: StockComponent },
          { path: 'command', component: CommandComponent },
          { path: 'devis', component: DevisComponent },
          {
            path: 'planningCrm/:ecran/:param_code/:date/:intervale',
            component: PlanningCrmComponent,
          },
        ],
      },
      //------------------------------QUALITE-------------------------------------
      {
        path: 'QUALITE',
        children: [
          { path: 'ficheEcart', component: EcartComponent },
          { path: 'reunion', component: ReunionComponent },
        ],
      },
      { path: 'suivi-production', component: SuiviProductionComponent },
      { path: 'recap-analyse', component: RecapAnalyseComponent },
      { path: 'recap-export', component: RecapExportComponent },
      { path: 'shopfloor_overview', component: ShopfloorOverviewComponent },
      { path: 'bureau_etude', component: BureauEtudeComponent },
      //------------------------------fin CRM-------------------------------------
      { path: '**', redirectTo: '/avt/home' },
    ],
    canActivate: [AuthGuard],
  },

  {
    path: 'simed',
    component: NavComponent,
    children: [
      { path: 'article', component: SimedArticleComponent },
      {
        path: 'reception-echantillon',
        component: SimedReceptionEchantillionComponent,
      },
      { path: 'analyse', component: SimedAnalyseComponent },
    ],
  },
  {
    path: 'kastelo',
    component: NavComponent,
    children: [
      { path: 'suivi', component: SuiviCodeBarreComponent },
      { path: 'dashboard', component: DashboardSuiviComponent },
    ],
  },
  {
    path: 'hierarchie',
    component: AjouterHierarchieComponent,
  },
  { path: 'bureau_etude', component: BureauEtudeComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
